
import './App.css';
import "./index.css"
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router } from "react-router-dom";
import Footer from './Components/Footer';




import Navbar from './Components/Navbar';
import PageRoutes from './Routes';


const App = () => (
<>
<Router>
    <Navbar/>
<PageRoutes/>
 <Footer/>  
</Router>
     
</>
    

);

export default App;